import { http } from '@/http/axios.js'

// 列表
export function getListAPI(params) {
  return http({
    url: `/api/store/order/coin/list`,
    method: 'get',
    params
  })
}

// 详情
export function getDetailAPI(id) {
  return http({
    url: `/api/store/order/coin/detail`,
    method: 'get',
    params: { id }
  })
}
